import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  postMethod,
  getMethod,
  patchMethod,
} from "../../services/ApiCallMethods";

export const addAdvisorManagement = createAsyncThunk(
  "advisorManagement/addAdvisor",
  async (advisorPayload, { rejectWithValue }) => {
    try {
      const response = await postMethod(`/api/addUser`, advisorPayload);
      const data = await response.json();
      return data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


export const addAdvisorforClient = createAsyncThunk(
  "advisorManagement/addAdvisorforClient",
  async (advisorPayload, { rejectWithValue }) => {
    try {
      const response = await postMethod(
        `/api/users-with-relationships`,
        advisorPayload
      );

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data?.error || "Something went wrong");
      }

      return data.data; // ✅ this goes to .unwrap()
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

export const getAdvisorList = createAsyncThunk(
  "advisorManagement/getAdvisorList",
  async (
    {
      currentPage,
      itemsPerPage,
      isActive,
      fromDate,
      toDate,
      investmentAmount,
      investmentType,
      search,
      NoPagination
    },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();

      if (isActive !== null) params.append("isActive", isActive);
      if (search) params.append("search", search);
      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);
      if (investmentAmount) params.append("investment_amount", investmentAmount);
      if (investmentType) params.append("investments", investmentType);
      if (NoPagination === false) params.append("NoPagination", false);
      if (currentPage) params.append("page", currentPage);
      if (itemsPerPage) params.append("limit", itemsPerPage);


      const url = `/api/advisors?${params.toString()}`;
      const response = await getMethod(url);
      const json = await response.json();
      return json || json;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch advisors"
      );
    }
  }
);

export const updateAdvisorManagement = createAsyncThunk(
  "advisorManagement/updateAdvisor",
  async (advisorPayload, { rejectWithValue }) => {
    try {
      const response = await patchMethod(
        `/api/advisors/${advisorPayload.id}`,
        advisorPayload
      );
      const data = await response.json();
      return data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went Wrong");
    }
  }
);

export const updateAdvisorStatus = createAsyncThunk(
  "advisorManagement/updateAdvisorStatus",
  async ({ id, is_active }, { rejectWithValue }) => {
    try {
      const response = await patchMethod(`/api/users/${id}/status`, {
        is_active,
      });
      const data = await response.json();
      return data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update status");
    }
  }
);

export const getClients = createAsyncThunk(
  "advisorManagement/getclients",
  async (id, { rejectWithValue }) => {
    try {
      const response = await getMethod(`/api/advisors/${id}/clients`);
      const json = await response.json();
      return json.data || json;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch clients");
    }
  }
);

export const searchAdvisors = createAsyncThunk(
  "advisorManagement/search",
  async (value, { rejectWithValue }) => {
    try {
      const response = await getMethod(
        `/api/advisors?page=1&limit=10&search=${value}`
      );
      const json = await response.json();
      return json.data || json;
    } catch (error) {

      return rejectWithValue(error.response?.data || "Advisor Not Found");
    }
  }
);

export const getAdvisorById = createAsyncThunk(
  "advisorManagement/getAdvisorById",
  async (clientId, { rejectWithValue }) => {
    try {
      const response = await getMethod(`/api/users/${clientId}`);
      const json = await response.json();
      return json.data || json;

    } catch (error) {
      return rejectWithValue(error.response?.data || "Advisor Not Found");
    }
  }
);

export const getAllclients = createAsyncThunk(
  "advisorManagement/getAllclients",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getMethod(`/api/getAllclients`);
      const json = await response.json();
      return json.data || json;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Advisor Not Found");
    }
  }
);

export const addClientToAdvisor = createAsyncThunk(
  "advisorManagement/addClientToAdvisor",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postMethod(`/api/user/inviteOnboardedAdvisor`, payload);
      const data = await response.json();

      if (data.error) {
        return rejectWithValue(data.error);
      }

      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to invite client");
    }
  }
);

export const getSecuritiesByAdvisorId = createAsyncThunk(
  "/api/advisorManagement/getSecuritiesByAdvisorId",
  async (advisorId, { rejectWithValue }) => {
    try {
      const response = await getMethod(`/profileSummary/getSecuritiesByAdvisorId/${advisorId}`);
      const json = await response.json();
      return json.data || json;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch securities");
    }
  }
);

export const getInvestmentsByAdvisorId = createAsyncThunk(
  "/api/advisorManagement/getInvestmentsByAdvisorId",
  async (advisorId, { rejectWithValue }) => {
    try {
      const response = await getMethod(
        `/profileSummary/getInvestmentsByAdvisorId/${advisorId}`
      );
      const json = await response.json();
      return json.data || json;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch investments"
      );
    }
  }
);

export const getSecuritiesByAdvisorIdAndClientId = createAsyncThunk(
  "/api/advisorManagement/getSecuritiesByAdvisorIdAndClientId",
  async ({ clientId, advisorId }, { rejectWithValue }) => {
    try {
      const response = await getMethod(
        `/profileSummary/getSecuritiesByAdvisorIdAndClientId/${clientId}/${advisorId}`
      );
      const json = await response.json();
      return json.data || json;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch securities"
      );
    }
  }
);

export const getInvestmentsByAdvisorIdAndClientId = createAsyncThunk(
  "/api/advisorManagement/getInvestmentsByAdvisorIdAndClientId",
  async ({ clientId, advisorId }, { rejectWithValue }) => {
    try {
      const response = await getMethod(
        `/profileSummary/getInvestmentsByAdvisorIdAndClientId/${clientId}/${advisorId}`
      );
      const json = await response.json();
      return json.data || json;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch investments"
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
  advisors: [],
  advisorSecurities: [],
  advisorInvestment: [],
  advisorClientRelatedSecurities: [],
  advisorClientRelatedinvestments: [],
  clients: {},
  clientsLoading: false,
  advisorLoading: false,
  advisorError: null,
  clientsError: null,
  advisorById: {},
  pagination: {},
  searchResult: [],
  allClientsloading: null,
  allClients: [],
  addClientSuccess: {},
  addClienterror: null
};

const advisorManagementSlice = createSlice({
  name: "advisorManagement",
  initialState,
  reducers: {
    resetAddClientState: (state) => {
      state.allClientsloading = false;
      state.addClientSuccess = null;
      state.addClienterror = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAdvisorManagement.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addAdvisorManagement.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(addAdvisorManagement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error;
        state.success = false;
      });
    builder

      .addCase(getAdvisorList.pending, (state) => {
        state.advisorLoading = true;
        state.advisorError = null;
      })
      .addCase(getAdvisorList.fulfilled, (state, action) => {
        state.advisorLoading = false;
        state.advisors = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(getAdvisorList.rejected, (state, action) => {
        state.advisorLoading = false;
        state.advisorError = action.payload;
      });

    builder
      .addCase(updateAdvisorManagement.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateAdvisorManagement.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(updateAdvisorManagement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });

    builder
      .addCase(updateAdvisorStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateAdvisorStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(updateAdvisorStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });

    // GET: financial advisor list
    builder
      .addCase(getClients.pending, (state) => {
        state.clientsLoading = true;
        state.clientsError = null;
      })
      .addCase(getClients.fulfilled, (state, action) => {
        state.clientsLoading = false;
        state.clients = {
          advisorId: action.payload.advisorId, // the `id` you passed
          clients: action.payload.clients || [],
        };
      })
      .addCase(getClients.rejected, (state, action) => {
        state.clientsLoading = false;
        state.clientsError = action.payload;
      });

    builder
      .addCase(searchAdvisors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchAdvisors.fulfilled, (state, action) => {
        state.loading = false;
        state.searchResult = action.payload;
        state.error = null;
      })
      .addCase(searchAdvisors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(getAdvisorById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdvisorById.fulfilled, (state, action) => {
        state.loading = false;
        state.advisorById = action.payload;
        state.error = null;
      })
      .addCase(getAdvisorById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(getAllclients.pending, (state) => {
        state.allClientsloading = true;
        state.error = null;
      })
      .addCase(getAllclients.fulfilled, (state, action) => {
        state.allClientsloading = false;
        state.allClients = action.payload;
        state.error = null;
      })
      .addCase(getAllclients.rejected, (state, action) => {
        state.allClientsloading = false;
        state.error = action.payload;
      });

    builder
      .addCase(addClientToAdvisor.pending, (state) => {
        state.allClientsloading = true;
        state.addClienterror = null;
      })
      .addCase(addClientToAdvisor.fulfilled, (state, action) => {
        state.allClientsloading = false;
        state.addClientSuccess = action.payload;
        state.addClienterror = null;
      })
      .addCase(addClientToAdvisor.rejected, (state, action) => {
        state.allClientsloading = false;
        state.addClienterror = action.payload;
      });
    builder
      .addCase(getInvestmentsByAdvisorIdAndClientId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInvestmentsByAdvisorIdAndClientId.fulfilled, (state, action) => {
        state.loading = false;
        state.advisorClientRelatedSecurities = action.payload;
      })
      .addCase(getInvestmentsByAdvisorIdAndClientId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(getSecuritiesByAdvisorId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSecuritiesByAdvisorId.fulfilled, (state, action) => {
        state.loading = false;
        state.advisorSecurities = action.payload;
      })
      .addCase(getSecuritiesByAdvisorId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(getInvestmentsByAdvisorId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInvestmentsByAdvisorId.fulfilled, (state, action) => {
        state.loading = false;
        state.advisorInvestment = action.payload;
      })
      .addCase(getInvestmentsByAdvisorId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(getSecuritiesByAdvisorIdAndClientId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSecuritiesByAdvisorIdAndClientId.fulfilled, (state, action) => {
        state.loading = false;
        state.advisorClientRelatedinvestments = action.payload;
      })
      .addCase(getSecuritiesByAdvisorIdAndClientId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default advisorManagementSlice.reducer;
export const { resetAddClientState } = advisorManagementSlice.actions;